import { initCaseStudiesReviewsSlider } from './pro-single-family-case-studies-world-of-mouth/pro-single-family-case-studies-word-of-mouth';
import YTPlayer from '../../scripts/components/YTPlayer';

window.onReady(() => {
  initCaseStudiesReviewsSlider();
  YTPlayer.init();
});
